/* Purely decorative cursor glow + trail; leaves the native cursor untouched.
   Skipped on touch devices (no real cursor to follow) and when the visitor
   has asked for reduced motion. */
(function () {
  if (window.matchMedia("(pointer: coarse)").matches) {
    return;
  }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  var DOT_COUNT = 6;
  var EASE = 0.35;

  var root = document.createElement("div");
  root.className = "pr-cursor-fx";
  root.setAttribute("aria-hidden", "true");

  var dots = [];
  for (var i = 0; i < DOT_COUNT; i++) {
    var el = document.createElement("div");
    el.className = "pr-cursor-fx__dot";
    root.appendChild(el);
    dots.push({ el: el, x: 0, y: 0 });
  }
  document.body.appendChild(root);

  var mouseX = 0;
  var mouseY = 0;
  var primed = false;

  window.addEventListener(
    "mousemove",
    function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!primed) {
        dots.forEach(function (dot) {
          dot.x = mouseX;
          dot.y = mouseY;
        });
        primed = true;
      }
      root.classList.add("pr-cursor-fx--active");
    },
    { passive: true }
  );

  document.addEventListener("mouseleave", function () {
    root.classList.remove("pr-cursor-fx--active");
  });

  function tick() {
    var targetX = mouseX;
    var targetY = mouseY;
    dots.forEach(function (dot) {
      dot.x += (targetX - dot.x) * EASE;
      dot.y += (targetY - dot.y) * EASE;
      dot.el.style.transform = "translate3d(" + dot.x + "px, " + dot.y + "px, 0)";
      targetX = dot.x;
      targetY = dot.y;
    });
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
